import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { genreSelector } from 'src/redux/app/selectors';
import FeatureBlock from 'components/FeatureBlock/FeatureBlock';
import Hero from 'components/Hero/Hero';
import request from 'helpers/request';
import Breadcrumb from 'components/_utility/Breadcrumb/Breadcrumb';
import { getContentBasePath } from 'helpers/utilities';
import { setError } from 'src/redux/app/actions';
import NoResults from 'components/_utility/NoResults/NewResults';
import { setFeatureCards } from 'src/redux/bikes/actions';
import Loader from 'components/_utility/Loader/Loader';
import { getFeatureCardCount } from 'src/redux/bikes/selectors';
import Modal from 'components/_utility/Modal/Modal';
import DisclaimerModal from 'components/DisclaimerModal/DisclaimerModal';
import { openModalSelector } from 'src/redux/configurator/selectors';
import { setSelectedDisclaimer, closeModal } from 'src/redux/configurator/actions';
import { Wrap, NoResultsWrap } from './Families.styled';

const Families = ({ genreId }) => {
  const [loadingBikes, setLoadingBikes] = useState(true);
  const [loadingFamilies, setLoadingFamilies] = useState(true);
  const [loadingHero, setLoadingHero] = useState(true);
  const [families, setFamilies] = useState([]);
  const [hero, setHero] = useState({});
  const genres = useSelector(genreSelector);
  const currentGenre = genres.find(genre => genre.id === genreId);
  const dispatch = useDispatch();
  const count = useSelector(getFeatureCardCount('family'));
  const openModals = useSelector(openModalSelector);

  useEffect(() => {
    const fetchFamilies = async () => {
      try {
        const res = await request(`/api/configurator/bikes/families?genre=${genreId}`);

        setFamilies(res.data.bikes);
        setLoadingFamilies(false);
      } catch (ex) {
        dispatch(setError(ex));
      }
    };

    fetchFamilies();

    const fetchGenreContent = async () => {
      try {
        const res = await request(`${getContentBasePath()}?genre=${genreId}`);

        setHero(res.data.hero);
        setLoadingHero(false);
      } catch (ex) {
        dispatch(setError(ex));
      }
    };

    fetchGenreContent();
  }, [dispatch, genreId]);

  useEffect(() => {
    const fetchBikes = async () => {
      try {
        const familyPromises = families.map(
          async family =>
            new Promise(async resolve => {
              const res = await request(`/api/configurator/bikes/models?family=${family.id}`);
              resolve({ id: family.id, cards: res.data.bikes });
            })
        );
        const familiesWithCards = await Promise.all(familyPromises);

        dispatch(setFeatureCards({ features: familiesWithCards, type: 'family' }));

        setLoadingBikes(false);
      } catch (ex) {
        dispatch(setError(ex));
      }
    };

    fetchBikes();
  }, [families]);

  if (loadingBikes || loadingFamilies || loadingHero || typeof count !== 'number') {
    return <Loader />;
  }

  return (
    <>
      <Hero
        buttons={[{ id: 'viewall', label: 'viewAllButton', to: '/bikes', white: true }]}
        title={hero.heroTitle}
        image={hero.heroImage}
        viewHidden
        fluid
        hasFilters
        isFamilyPage
      />
      <Wrap>
        {count ? (
          families.map(family => (
            <FeatureBlock
              key={family.id}
              id={family.id}
              title={family.name}
              description={family.intro}
              familyCards={false}
            />
          ))
        ) : (
          <NoResultsWrap>
            <NoResults />
          </NoResultsWrap>
        )}
        {openModals.disclaimer ? (
          <Modal onClose={() => [dispatch(closeModal('disclaimer')), dispatch(setSelectedDisclaimer(null))]}>
            <DisclaimerModal />
          </Modal>
        ) : null}
      </Wrap>
      <Breadcrumb
        additionalLinks={
          currentGenre
            ? [
                {
                  text: currentGenre.title,
                  siteLink: false,
                },
              ]
            : []
        }
      />
    </>
  );
};

export default Families;
